import { render, staticRenderFns } from "./DarkFeatures.vue?vue&type=template&id=35f1ced5&scoped=true&"
import script from "./DarkFeatures.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkFeatures.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1ced5",
  null
  
)

export default component.exports